// src/components/AccessControl.js
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase";

const AccessControl = ({ children }) => {
  const { childId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user || !childId) return;

      try {
        const ref = doc(db, "children", childId);
        const snap = await getDoc(ref);
        const data = snap.exists() ? snap.data() : null;

        if (!data || !data.access?.includes(user.email)) {
          navigate("/denied");
        } else {
          setChecking(false);
        }
      } catch (err) {
        // Firestore rules deny read access to children the user isn't on
        // the `access` list for — treat that the same as "no access".
        navigate("/denied");
      }
    };

    checkAccess();
  }, [user, childId, navigate]);

  if (checking) return null;
  return children;
};

export default AccessControl;
